import { GzExchangeAntispamWebComponent } from './component/GzExchangeAntispamWebComponent';

export { GzExchangeAntispamWebComponent };
